export class EventContextBridge {
  #context;
  #supportedEvents;
  #listeners = new Map();

  constructor ({ context = '', supportedEvents = [] }) {
    this.#context = context;
    this.#supportedEvents = new Set(supportedEvents);
  }

  #validateEventName (eventName) {
    if (!this.#supportedEvents.has(eventName)) {
      throw new Error(`${this.#context} event "${eventName}" is not supported.`);
    }
  }

  #getEventName (eventName) {
    return `${this.#context}.${eventName}`;
  }

  on (eventName, listener) {
    this.#validateEventName(eventName);

    const boundListener = ({ detail }) => listener(detail);
    this.#listeners.set(listener, boundListener);
    document.addEventListener(this.#getEventName(eventName), boundListener);
  }

  off (eventName, listener) {
    this.#validateEventName(eventName);

    const boundListener = this.#listeners.get(listener);
    if (boundListener) {
      document.removeEventListener(this.#getEventName(eventName), boundListener);
      this.#listeners.delete(listener);
    }
  }
}
